import { CALL_API } from '../../middleware/api';
import * as ActionTypes from '../phoneConfirmation';
var fetchPhoneConfirmation = function (data) {
    var _a;
    return (_a = {
            type: ActionTypes.PHONE_CREATE_CONFIRMATION
        },
        _a[CALL_API] = {
            endpoint: "/api/gambler/phone/create-confirmation/".concat(data.phone),
            method: 'post',
            types: [
                ActionTypes.SUCCESS_PHONE_CREATE_CONFIRMATION,
                ActionTypes.FAILURE_PHONE_CREATE_CONFIRMATION
            ],
            credentials: true
        },
        _a);
};
export function phoneConfirmation(data) {
    return function (dispatch) {
        return dispatch(fetchPhoneConfirmation(data));
    };
}
var fetchPhoneConfirm = function (data) {
    var _a;
    return (_a = {
            type: ActionTypes.PHONE_CONFIRM
        },
        _a[CALL_API] = {
            endpoint: "/api/gambler/phone/confirm/".concat(data.code),
            method: 'post',
            types: [
                ActionTypes.SUCCESS_PHONE_CONFIRM,
                ActionTypes.FAILURE_PHONE_CONFIRM
            ],
            credentials: true
        },
        _a);
};
export function phoneConfirm(data) {
    return function (dispatch) {
        return dispatch(fetchPhoneConfirm(data));
    };
}



// WEBPACK FOOTER //
// ./src/actions/creators/phoneConfirmation.js